const actionTypes = require('constants/actionTypes');
// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
//@ actions
const signaturePatternActions = require('actions/signaturePattern');

const setVisibleStep = (step) => (dispatch) => {
    dispatch({
        type: actionTypes.SEND_PIN_SET_VISIBLE_STEP,
        payload: {
            step
        }
    });
};

const validateStep = (step) => (dispatch) => {
    dispatch({
        type: actionTypes.SEND_PIN_SET_STEP_VALID_VALIDATE,
        payload: {
            step
        }
    });
};

const modifyRequest = () => ({
    type: actionTypes.SEND_PIN_REQUEST
});

const modifySuccess = (data) => ({
    type: actionTypes.SEND_PIN_SUCCESS,
    payload: {
        data
    }
});

const modifyFailure = (error) => ({
    type: actionTypes.SEND_PIN_FAILURE,
    payload: {
        error
    }
});

const reset = () => ({
    type: actionTypes.SEND_PIN_RESET
});


function setWillCancel() {
    return {
        type: actionTypes.SEND_PIN_CANCEL,
    };
}

const sendPinSuccess = (cardId) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
            var immCard = getState().cards.getIn(['byId', cardId]);
            var params = {
                query: {
                    contratoTarjeta: {
                        numerodecontrato: immCard.getIn(['contract', 'number']),
                        producto: immCard.getIn(['contract', 'product'])
                    },
                    dataToken,
                    pan: immCard.get('number')
                }
            };
            dispatch(modifyRequest());
            return APIPost({
                dispatch,
                endpoint: 'sendPin',
                params: params
            })
            .then(response => dispatch(modifySuccess(response)))
            .catch(response => {
                if (!!response.error) {
                    dispatch(modifyFailure(response.error));
                } else {
                    throw response;
                }
            });
        };

    signaturePatternActions.validateAndExecute(dispatch, getState, callback);

}

module.exports = {
    setVisibleStep,
    validateStep,
    sendPinSuccess,
    reset,
    setWillCancel
}
